import React from 'react'
import {$$} from '../../helpers/localization'
import {Link} from 'react-router-dom'
import {Routes} from '../../constants/routes'

export function NotificationsBanner({unreadCount}) {
    if (!unreadCount || unreadCount <= 0) {
        return null;
    }

    return (
        <div className="landing-notifications-banner">
            <div className="high-shadow-container landing-container d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                    <i className="flaticon2-bell-alarm-symbol notifications-banner-icon"/>
                    <span className="notifications-banner-text">
                        <strong>{unreadCount}</strong> {$$('unread_notifications')}
                    </span>
                </div>
                <Link className="small-link-blue" to={Routes.NOTIFICATIONS}>
                    {$$('see_all_label')}
                </Link>
            </div>
        </div>
    );
}
